import { useTranslation } from 'react-i18next';

export default function LoadingOverlay({ message }: { message?: string }) {
  const { t } = useTranslation();
  
  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'grid',
        placeItems: 'center',
        background: 'rgba(0,0,0,0.35)',
        zIndex: 1000,
      }}
    >
      <div
        className="card"
        style={{ padding: 20, display: 'flex', alignItems: 'center', gap: 12 }}
      >
        <div className="spinner" aria-hidden />
        <div style={{ fontWeight: 600 }}>{message ?? t('loading')}</div>
      </div>
    </div>
  );
}
